import { Loader2, Download } from 'lucide-react';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from '../ui/dialog';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

/**
 * Modal that displays a confirmed guest's QR code so the promoter can share
 * or download it (WhatsApp, email, printout).
 *
 * Props:
 *   open, onOpenChange       — dialog state
 *   guest                    — { id, name, slot_number } or null
 *   qrDataUri                — data URI of the QR PNG, null while loading
 *   loading                  — spinner flag
 */
export default function GuestQrDialog({ open, onOpenChange, guest, qrDataUri, loading }) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="bg-[#0A0A0A] border-zinc-800 text-white max-w-md" data-testid="promoter-qr-dialog">
        <DialogHeader>
          <DialogTitle className="font-['Josefin_Sans'] text-2xl">GUEST QR</DialogTitle>
        </DialogHeader>
        <div className="mt-2 text-center">
          {guest && (
            <>
              <p className="font-['Josefin_Sans'] text-xl text-white">{guest.name}</p>
              {guest.slot_number != null && (
                <p className="font-mono text-xs text-[#B5FF00] tracking-widest mt-1">SLOT #{guest.slot_number}</p>
              )}
            </>
          )}
          <div className="mt-4">
            {loading || !qrDataUri ? (
              <div className="h-64 flex items-center justify-center">
                <Loader2 className="animate-spin text-[#B5FF00]" size={32} />
              </div>
            ) : (
              <div className="bg-white p-4 inline-block">
                <img src={qrDataUri} alt="Guest QR" className="w-64 h-64 block" data-testid="promoter-qr-image" />
              </div>
            )}
          </div>
          {guest && qrDataUri && (
            <a
              href={`${API}/rsvp/qr/${guest.id}.png`}
              download={`unight-guest-${guest.slot_number || guest.id}.png`}
              target="_blank"
              rel="noopener noreferrer"
              className="btn-primary mt-4 inline-flex items-center gap-2"
              data-testid="promoter-qr-download-btn"
            >
              <Download size={16} /> DOWNLOAD QR
            </a>
          )}
          <p className="text-zinc-500 font-mono text-xs mt-4 tracking-wider">
            Share this QR with the guest via WhatsApp / email. They can scan it at the door — or you can scan it here.
          </p>
        </div>
      </DialogContent>
    </Dialog>
  );
}
